import { MgBalanced } from '@montugroup/icons';
import MdNightlightRound from '@mui/icons-material/NightlightRound';
import MdWbSunny from '@mui/icons-material/WbSunny';
import type { SvgIcon } from '@mui/material';

import type { ProductStrainKey } from '@montugroup/circuit-shared/types/index';
import { ProductStrainKeys } from '@montugroup/circuit-shared/types/index';

interface StrainIconDefn {
  icon: typeof SvgIcon;
  color: string;
  bgColor: string;
}

const ProductStrainsMap: Record<ProductStrainKey, StrainIconDefn> = {
  [ProductStrainKeys.SATIVA]: {
    icon: MdWbSunny,
    color: '#FFA726',
    bgColor: '#FFF3E0',
  },
  [ProductStrainKeys.INDICA]: {
    icon: MdNightlightRound,
    color: '#4DB6AC',
    bgColor: '#E0F2F1',
  },
  [ProductStrainKeys.HYBRID]: {
    icon: MgBalanced,
    color: '#555555',
    bgColor: '#F5F5F5',
  },
} as const;

export default ProductStrainsMap;
